import {JETMS} from "@jet/jetms-client-sdk/dist/window"

export const getAccessToken = () => {
  if (typeof JETMS !== "undefined") {
    return JETMS.user.accessToken
  }
  return localStorage.getItem('access_token')
}

export const getTenant = () => {
  if (typeof JETMS !== "undefined") {
    return JETMS.activeCountry.code.toLowerCase()
  }
  return localStorage.getItem('tenant')
}



// WEBPACK FOOTER //
// ./src/api/jetms-interop.js